module.exports = __webpack_public_path__ + "static/oxaco-logo-white-e27bc1ffbd32a07262b00f5dd2f04148.svg";